import * as React from 'react';
import { useState } from 'react';
import InputMask from 'react-input-mask';
import { Button, Col, Form, FormFeedback, FormGroup, Input, Modal, Row } from 'reactstrap';
import { IGlobalContextProps, withGlobalContext } from 'src/context/global.context';
import { register } from 'src/services';
import { isEmail, isMobilePhoneNumber , isPassword, isPhoneNumber } from 'src/utils/validation';
import { Svg } from '../Svg';

interface ILoginModalProps {
  isOpen: boolean;
  toggleLoginModal: () => void;
  toggleSignupModal: () => void;
  toggleSignupConfirmationModal: () => void;
}

const SignupModal: React.SFC<ILoginModalProps & IGlobalContextProps> = ({
  context,
  isOpen,
  toggleLoginModal,
  toggleSignupModal,
  toggleSignupConfirmationModal,
}) => {
  const [state, setState] = useState({
    invalid: {
      email: false,
      other: false,
    },
    signup: {
      address: {
        mobilephone: '',
        phone: '',
      },
      email: '',
      firstname: '',
      lastname: '',
      password: '',
      status: 'registration',
      type: 'client',
    },
  });
  
  const isValid =
  !!state.signup.lastname &&
  ( !!state.signup.password  &&   isPassword(state.signup.password)) &&
  (!!state.signup.address.mobilephone && isMobilePhoneNumber(state.signup.address.mobilephone)) &&
  (!!!state.signup.address.phone || isPhoneNumber(state.signup.address.phone)) ;

  const toggleType = () => {
    setState({
      ...state,
      signup: {
        ...state.signup,
        type: state.signup.type === 'client' ? 'consultant' : 'client',
      },
    });
  };

  const handleChange = (e: React.ChangeEvent<Element>) => {
    setState({
      invalid: {
        email: false,
        other: false,
      },
      signup: {
        ...state.signup,
        [(e.target as any).name]: (e.target as any).value,
      },
    });
  };

  const handleAddressChange = (e: React.ChangeEvent<Element>) => {
    setState({
      invalid: {
        email: false,
        other: false,
      },
      signup: {
        ...state.signup,
        address: {
          ...state.signup.address,
          [(e.target as any).name]: (e.target as any).value,
        },
      },
    });
  };

   const handleLogout = () => {
    context.updateUser(true);
   };

  const handleSignup = async () => {
    if (isValid) {
      try {
        const signupResponse = await register(state.signup);
        if (signupResponse) {
          closeSignupModal();
          handleLogout();
          toggleSignupConfirmationModal();
        }
      } catch (error) {
        if (error && error.response && error.response.status === 400) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.errorCode !== 'empty_lastname'
          ) {
            setState({
            ...state,
              invalid: { email: true, other: false },
              // signup: {
              //   address: {
              //     mobilephone: '',
              //     phone: '',
              //   },
              //   email: '',
              //   firstname: '',
              //   lastname: '',
              //   password: '',
              //   status: 'registration',
              //   type: 'client',
              // },
            });
          } else {
            setState({
              ...state,
              invalid: { email: false, other: true },
            });
          }
        }
      }
    } else {
      setState({
        ...state,
        invalid: { email: false, other: true },
      });
    }
  };

  const closeSignupModal = () => {
    setState({
      invalid: { email: false, other: false },
      signup: {
        address: {
          mobilephone: '',
          phone: '',
        },
        email: '',
        firstname: '',
        lastname: '',
        password: '',
        status: 'registration',
        type: 'client',
      },
    });
    toggleSignupModal();
  };

  const handleLoginClick = () => {
    closeSignupModal();
    toggleLoginModal();
  };

  return (
    <Modal className='position-relative' isOpen={isOpen}>
      <Svg
        className='position-absolute'
        fill='primary'
        width={280}
        height={210}
        opacity={0.1}
        src='bulle-popin'
        style={{ top: '-19px', left: '-15px' }}
      />
      <div className='d-flex justify-content-end p-3'>
        <Svg fill='dark' src='close' width={16} onClick={closeSignupModal} />
      </div>
      <div className='d-flex justify-content-between align-items-center pl-5 pr-5'>
        <h3>
          Inscrivez
          <br />
          vous
        </h3>
        <div className='d-flex flex-column'>
          <span className='text-primary'>J'ai déjà un compte</span>
          <Button
            className='btn-sm text-uppercase text-white bg-primary border-0 mt-2'
            onClick={handleLoginClick}
          >
            Connexion
          </Button>
        </div>
      </div>
      <Form className='p-5' style={{ zIndex: 1 }}>
        <Row className='d-flex justify-content-end align-items-center pt-5'>
          <Col xs='6'>
            <div
              className={`text-center rounded-pill ${
                state.signup.type === 'client'
                  ? 'text-white bg-success border-0'
                  : 'text-primary bg-white border border-primary'
              } p-2`}
              onClick={toggleType}
            >
              Je suis client
            </div>
          </Col>
          <Col xs='6'>
            <div
              className={`text-center rounded-pill ${
                state.signup.type === 'consultant'
                  ? 'text-white bg-secondary border-0'
                  : 'text-primary bg-white border border-primary'
              } p-2`}
              onClick={toggleType}
            >
              Je suis consultant
            </div>
          </Col>
        </Row>
        <FormGroup>
          <Input
            className='mt-3'
            type='text'
            name='lastname'
            placeholder='Nom*'
            invalid={state.invalid.other && !!!state.signup.lastname}
            value={state.signup.lastname}
            onChange={handleChange}
          />
          <FormFeedback>Merci de renseigner ce champ</FormFeedback>
        </FormGroup>
        <FormGroup>
          <Input
            className='mt-3'
            type='text'
            name='firstname'
            placeholder='Prénom'
            value={state.signup.firstname}
            onChange={handleChange}
          />
        </FormGroup>
        <FormGroup>
          <Input
            type='email'
            name='email'
            placeholder='E-mail*'
            invalid={(state.invalid.email &&  isValid)  || (state.invalid.other &&  !!!state.signup.email)  ||  (!!state.signup.email  && !isEmail(state.signup.email)) } 
            value={state.signup.email}
            onChange={handleChange}
          />
          <FormFeedback>
            {isEmail(state.signup.email)
              ? `Cette adresse e-mail est déjà associée à un compte`
              : `Adresse e-mail non valide`}
          </FormFeedback>
        </FormGroup>
        <FormGroup>
          <Input
            className='mt-3'
            type='password'
            name='password'
            placeholder='Mot de passe*'
            invalid={(state.invalid.other &&  !isPassword(state.signup.password) ) ||  (!!state.signup.password && !isPassword(state.signup.password) )   }
            value={state.signup.password}
            onChange={handleChange}
          />
          <FormFeedback>
        {!state.signup.password 
            ? 'Merci de choisir un mot de pass'
            : 'Votre mot de passe doit contenir 8 caractères minimum avec au moins une majuscule, un chiffre et un caractère spécial'}
        </FormFeedback>
        </FormGroup>
        <FormGroup>
          <Input
            className='mt-3'
            type='text'
            name='mobilephone'
            placeholder='Mobile*'
            invalid={
              (state.invalid.other  && (!!!state.signup.address.mobilephone || !isMobilePhoneNumber(state.signup.address.mobilephone)))
              ||  (!!state.signup.address.mobilephone && !isMobilePhoneNumber(state.signup.address.mobilephone))
          }
            value={state.signup.address.mobilephone}
            onChange={handleAddressChange}
            tag={InputMask}
            mask="+3\3 9 99 99 99 99" 
            maskChar={null} 
          />
           <FormFeedback>
            {!state.signup.address.mobilephone 
            ? 'Merci de renseigner ce champ'
            : null}
        </FormFeedback>
        </FormGroup>
        <FormGroup>
          <Input
            className='mt-3'
            type='text'
            name='phone'
            placeholder='Téléphone'
            invalid={
              !!state.signup.address.phone &&
              !isPhoneNumber(state.signup.address.phone)
            }
            value={state.signup.address.phone}
            onChange={handleAddressChange}
            tag={InputMask}
            mask="+3\3 9 99 99 99 99" 
            maskChar={null} 
          />
        </FormGroup>
        <FormGroup>
          <span className='d-block mb-3'>
            * Champs obligatoires 
          </span>
        </FormGroup>
        <Row className='d-flex'>
          <Col xs='12'>
            <Button
              className='text-uppercase text-white bg-primary float-right border-0 mt-3'
              onClick={handleSignup}
            >
              Valider
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export const SignupModalWithGlobalContext = withGlobalContext(SignupModal);



// WEBPACK FOOTER //
// ./src/components/shared/Modals/SignupModal.tsx